import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Loader } from 'react-loaders';
import { getRequest, postRequest } from '../../../api/ApiService';

import CheckboxInactive from '../../../containers/assets/checkbox.png';
import CheckboxActive from '../../../containers/assets/checkbox-active.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 29px;
  margin-top: 34px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Option = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  ${p => !p.isReadOnly && `
    &:hover {
      cursor: pointer;
    }
  `}

  ${p => p.isReadOnly && `
    &:hover {
      cursor: default;
    }
  `}
`;

class TriviaMultipleChoice extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      values: [],
      isReadOnly: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('disabled');

    this.props.setFetchData(true);
    getRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .then(res => {
        const answer = res.body.results.find(i => (
          i.user === userId
          && i.trivia_question === questionId
          && i.course_trivia === triviaId
        ));
        const isReadOnly = !!answer;
        const values = answer ? answer.pickedoptions.map(i => i.option_choice) : [];

        if (isReadOnly) {
          this.props.setMode('basic');
        }

        this.props.setFetchData(false);
        this.setState({
          isReadOnly,
          values,
        });
      })
      .catch(err => {});
  }

  setValue = value => {
    const { values } = this.state;

    if (values.includes(value)) {
      this.setState({
        values: values.filter(i => i !== value),
      }, () => {
        this.prevalidate();
      });
    } else {
      this.setState({
        values: [
          ...values,
          value,
        ],
      }, () => {
        this.prevalidate();
      });
    }
  }

  prevalidate = () => {
    const { values } = this.state;

    if (values.length > 0) {
      this.props.setMode('validate', this.validate);
    } else {
      this.props.setMode('disabled');
    }
  }

  validate = () => {
    const { data } = this.props;
    const { values } = this.state;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('loading');
    let counter = 0;
    postRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .send({
        user: userId,
        trivia_question: questionId,
        course_trivia: triviaId,
        pickedoptions: values.map(i => ({ option_choice: i, order: ++counter })),
      })
      .then(res => {
        if (res.body.is_correct === 'Yes') {
          this.props.showConfetti();
        } else {
          this.props.showIncorrectMessage();
        }

        this.setState({
          isReadOnly: true,
        });

        this.props.setMode('basic');
      })
      .catch(err => {
        this.props.setMode('basic');
      });
  }

  render() {
    const { values, isReadOnly } = this.state;
    const { data, stage, isFetchData } = this.props;
    const { num, text, choices } = data;

    return isFetchData ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        <Text2>{num}. {text}</Text2>
        <Options>
          {choices.map(choice => (
            <Option
              key={`option-choice-${choice.id}`}
              isActive={values.includes(choice.id)}
              onClick={() => isReadOnly ? {} : this.setValue(choice.id)}
              isReadOnly={isReadOnly}
            >
              {!values.includes(choice.id) && <img src={CheckboxInactive} alt="checkbox inactive icon" />}
              {values.includes(choice.id) && <img src={CheckboxActive} alt="checkbox active icon" />}
              {choice.text}
            </Option>
          ))}
        </Options>
      </Wrapper>
    );
  }

}

export default TriviaMultipleChoice;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/MultipleChoice.js